import star from "../images/svg/star.svg";
import rocket from "../images/svg/rocket.svg";
import heart from "../images/svg/heart.svg";
import bell from "../images/svg/bell.svg";
import paw from "../images/svg/paw.svg";
import puzzle from "../images/svg/puzzle.svg";
import fish from "../images/svg/fish.svg";
import leaf from "../images/svg/leaf.svg";

export const svgIcons = {
  1: {
    svg: star,
    color: "#FF6600",
    anchor: [9, 7],
  },
  2: {
    svg: paw,
    color: "#006633",
    anchor: [9, 7],
  },
  3: {
    svg: heart,
    color: "red",
    anchor: [9, 7],
  },
  4: {
    svg: puzzle,
    color: "#663333",
    anchor: [9, 7],
  },
  5: {
    svg: bell,
    color: "blue",
    anchor: [9, 7],
  },
  6: {
    svg: fish,
    color: "fuchsia",
    anchor: [9, 7],
  },
  7: {
    svg: leaf,
    color: "#006633",
    anchor: [9, 7],
  },
  8: {
    svg: rocket,
    color: "#990000",
    anchor: [9, 7],
  },
};
